import {useNavigate} from 'react-router-dom';
import {Button} from 'alm-react-components';
import CarouselSection from '../../common/CarouselSection';
import {useTranslation} from 'react-i18next';
import { APPROUTES, constants } from '../../../assets/constants/constants';
import { useContext, useEffect, useState } from 'react';
import { compareByWeek, LibraryFilteration } from '../../../lib/utils';
import { AppContext } from '../../../context/AppProvider';

const BullentinSection = ({
  bulletins,
  addBookMark,
  deleteBookMark,
  catalogId,
  tagsData
}: {
  bulletins: any;
  addBookMark: any;
  deleteBookMark: any;
  catalogId: any;
  tagsData:any
}) => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [filteredVideos,setFilteredVideos]=useState<any[]>([]);
  const { state } = useContext(AppContext);

  useEffect(()=>{
    const data =  LibraryFilteration(tagsData,bulletins,constants.NEW_BULLETINS)
    const sortedData=data?.sort(compareByWeek)
    setFilteredVideos(sortedData);
    },[tagsData,bulletins])


  if (!filteredVideos || filteredVideos.length === 0) {
    return null;
  }

  return (
    <div className="mt-14 mb-14 xl:px-32 lg:px-8 md:px-8 px-5">
      <div className="flex flex-wrap justify-between md:flex-nowrap">
        <h2 className="text-3xl font-barlowLight max-md:mb-4">
        <span dangerouslySetInnerHTML={{ __html: (t('Library.bulletin')) }} /></h2>
        {!state?.keyword&&( 
          <Button
          onClick={() => navigate(`/bulletins/${catalogId?.id}`)}
          variant="outline"
          className="text-base font-normal px-6 py-1 h-9 dark:bg-fillMidGrayCard border-0"
        >
          <span dangerouslySetInnerHTML={{ __html: (t('Common.seeAll')) }} />
        </Button>)}
      </div>
      <CarouselSection
        data={filteredVideos}
        addBookMark={addBookMark}
        deleteBookMark={deleteBookMark}
        type={constants.BULLETINS}
        id={catalogId?.id}
        from={APPROUTES.library}
      />
    </div>
  );
};

export default BullentinSection;
